<ion-header>
  <ion-toolbar>
    <ion-title>Select user</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  @if(!isLoading) {
  <div class="ion-padding" *ngIf="teamAdmins?.coaches?.length else noAdmins">
    <div class="heading">
      <p>Which user are you?</p>
    </div>
    <ion-list *ngIf="teamAdmins?.coaches?.length else noAdmins">

      <!-- Loop through coaches -->
      <ion-item (click)="claimStaff(ta._id)" class="content-width" *ngFor="let ta of nonPendingCoaches(); let i = index;">
        <ion-avatar slot="start">
          <img *ngIf="ta?.profile_image; else defaultAvatar" [src]="ta.profile_image" alt="Profile Image" />
        </ion-avatar>

        <ng-template #defaultAvatar>
          <ion-avatar>
            <ion-icon name="person-circle-outline" size="large"></ion-icon>
          </ion-avatar>
        </ng-template>

        <ion-label>
          {{ ta?.first_name }} {{ ta?.last_name }}
          <p>{{ ta?.phone }}</p>
        </ion-label>

       </ion-item>
    </ion-list>
  </div>
  <ng-template #noAdmins>
    <ion-item>
      <ion-label>{{'No team admins found.' | translate}}</ion-label>
    </ion-item>
  </ng-template>
  }


  @if(isLoading) {
  <div class="ion-padding" *ngFor="let item of [0, 1, 2]">
    <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
  </div>
  }
</ion-content>